import { useEffect, useState } from "react"

import { APIS } from "../../../config/apis"
import { REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from "../../../utils/apiweb"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";

import { isNull, isValidNumber } from "../../../utils/validator"
import { FormError, FormLabel, InputNumber, Modal } from "../../common"
import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const entityInit = {
    id: -1,
    codigo: '',
    nombre: '',
    orden: '',
    coeficiente: 0,
}

const CategoriaUbicacionModal = (props) => {
    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, , formSet] = useForm({
        codigo: '',
        nombre: '',
        orden: '',
        coeficiente: 0,
    })

    useEffect(() => {
        setEntity(props.item)
        formSet({
            codigo: props.item.codigo,
            nombre: props.item.nombre,
            orden: props.item.orden,
            coeficiente: props.item.coeficiente,
        })
    }, [props.item])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (!isValidNumber(formValues.coeficiente, true)) errors.coeficiente = 'Ingresá un número mayor a cero'

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (props.editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CATEGORIA_UBICACION,
            props.editMode === 'modify' ? `/${entity.id}` : '',
            {...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0},
            res => res.json().then(() => {
                setIsLoading(false)
                props.onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = props.editMode === 'view'

    return (
        <Modal
            onEscape={props.onCancel}
            title="Categoría de ubicación"
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            size="lg"
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                            name="orden"
                            type="number"
                            placeholder=""
                            className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                            value={formValues.orden}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="coeficiente" required>Coeficiente</FormLabel>
                        <InputNumber
                            name="coeficiente"
                            type="number"
                            placeholder=""
                            className={`form-control ${errorOf('coeficiente') ? 'is-invalid' : ''}`}
                            precision={2}
                            value={formValues.coeficiente}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('coeficiente')} />
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={() => onConfirm()}>Guardar</button>
                    )}
                </div> 
            )}
        />
    )
}

export default CategoriaUbicacionModal
